import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';

export default class BN_TreatmentPlanCategoryModalityCitation extends BackboneElement {
    static __className = 'BN_TreatmentPlanCategoryModalityCitation';

    __objectStructure = {
        text: String, // The citation text with HTML tags stripped (author, year, etc.)
        title: String, // The italicized work title
        url: String, // A single source URL
        isAuthority: Boolean, // True when authored by a leading authority (formerly a leading '*')
    };

    constructor(constructJson, className = 'BN_TreatmentPlanCategoryModalityCitation') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        const json = merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
        // Aidbox rejects empty-string scalars as invalid FHIR. Construction sets fields
        // directly (bypassing the ''->undefined setter), so drop any blank scalar here
        // rather than persist it (mirrors the legacy importer's empty-string filter).
        ['text', 'title', 'url'].forEach((key) => {
            if (json[key] === '') delete json[key];
        });
        return json;
    }
}
